module.exports = __webpack_public_path__ + "img/115012.f5a85f6a.png";